// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  selectGroupsResponse,
  selectShowEmpty,
  selectShowError,
  selectShowList,
  selectShowShowAll,
  selectShowSkeleton,
} from '@coa/app/home/modules/dashboard/modules/dashboard-groups/store/dashboard-groups.selectors';
import { CustomGroup } from '@coa/app/home/modules/dashboard/modules/dashboard-groups/models/custom-group';

@Component({
  selector: 'coa-dashboard-groups-body',
  templateUrl: './dashboard-groups-body.component.html',
  styleUrls: ['./dashboard-groups-body.component.scss'],
})
export class DashboardGroupsBodyComponent {
  @Input() categoryId: string;
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;

  showSkeleton$: Observable<boolean> = this.store$.pipe(select(selectShowSkeleton));
  showList$: Observable<boolean> = this.store$.pipe(select(selectShowList));
  showShowAll$: Observable<boolean> = this.store$.pipe(select(selectShowShowAll));
  showError$: Observable<boolean> = this.store$.pipe(select(selectShowError));
  showEmpty$: Observable<boolean> = this.store$.pipe(select(selectShowEmpty));

  groups$: Observable<CustomGroup[]> = this.store$.pipe(select(selectGroupsResponse));

  constructor(
    private router: Router,
    private store$: Store,
  ) {
  }
}
